import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { bool_type, lambda_type, class_type, union_type, unit_type, int32_type, list_type, equals, record_type, option_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { FunctionComponent_Of_Z5A158BBF } from "../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { delayAsync, optToStr } from "../Utils.js";
import { getTranslationFrom, LoadState_zip, LoadState$2, SaveStatus as SaveStatus_1 } from "../Global.js";
import { SelectOption, ValueProp as ValueProp_1, SelectOption_get_getDefault, selectOption } from "../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library.3.7.20/String.js";
import { DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../fable_modules/fable-library.3.7.20/MapUtil.js";
import { ButtonProps, ButtonProps_get_getDefault, ButtonKind, wrappedButton } from "../Components/Button/Button.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";
import { useSelector, useDispatch } from "../Redux/Store.js";
import { loadCountriesThunk } from "../Api/Misc.js";
import { dotsLoading } from "../ViewUtils.js";
import { info, error } from "../Components/Message/Message.js";
import { singleton as singleton_1, append, cons, map } from "../fable_modules/fable-library.3.7.20/List.js";
import "../../src/Admin/SiteWideMessage.scss";


export class CountryMessage extends Record {
    constructor(ThreeLetterCountryCode, Message) {
        super();
        this.ThreeLetterCountryCode = ThreeLetterCountryCode;
        this.Message = Message;
    }
}

export function CountryMessage$reflection() {
    return record_type("Admin.SiteWideMessage.CountryMessage", [], CountryMessage, () => [["ThreeLetterCountryCode", string_type], ["Message", option_type(string_type)]]);
}

export function Api_loadSiteWideMessages() {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/SiteWideMessage/All"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(list_type(CountryMessage$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(CountryMessage$reflection()), arg, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(CountryMessage$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function Api_saveSiteWideMessage(dto, isNew) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/SiteWideMessage/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const validUrl = matchValue.fields[0];
        if (isNew) {
            const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
            let parseFn;
            const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
            parseFn = ((arg_1) => {
                const str = arg_1;
                return equals(int32_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(int32_type, arg, Http_get_ExtraCoders().Value)), str);
            });
            const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CountryMessage$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
            return singleton.Delay(() => {
                let a;
                return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(validUrl))))))), singleton.Bind(a, Http_send)), (_arg) => {
                    const response = _arg;
                    return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
                });
            });
        }
        else {
            const requestCaseStrategy_1_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
            let parseFn_1;
            const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
            parseFn_1 = ((arg_1_1) => {
                const str_1 = arg_1_1;
                return equals(int32_type, string_type) ? (new FSharpResult$2(0, str_1)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(int32_type, arg_2, Http_get_ExtraCoders().Value)), str_1);
            });
            const jsonStr_1 = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CountryMessage$reflection()), requestCaseStrategy_1_1, Http_get_ExtraCoders().Value, false)(dto));
            return singleton.Delay(() => {
                let a_2;
                return singleton.Bind((a_2 = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr_1), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(validUrl))))))), singleton.Bind(a_2, Http_send)), (_arg_1) => {
                    let response_2;
                    return singleton.Return((response_2 = _arg_1, (response_2.statusCode === 200) ? (equals(int32_type, string_type) ? (new FSharpResult$2(0, response_2.responseText)) : parseFn_1(response_2.responseText)) : (new FSharpResult$2(1, response_2.responseText))));
                });
            });
        }
    }
}

export const renderCountryMessage = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, inputRecord, props_3, inputRecord_1;
    const selectedCountryState = react.useState(props.CountryMessage.ThreeLetterCountryCode);
    const messageState = react.useState(optToStr(props.CountryMessage.Message));
    const saveStatusState = react.useState(new SaveStatus_1(0));
    const children_4 = [(children = [selectOption((inputRecord = SelectOption_get_getDefault(), new SelectOption(new ValueProp_1(0, selectedCountryState[0], (e) => {
        selectedCountryState[1](Browser_Types_Event__Event_get_Value(e));
    }), "site-wide-message-countries", props.Countries, inputRecord.Classes, "Land", !isNullOrWhiteSpace(props.CountryMessage.ThreeLetterCountryCode), inputRecord.HTMLProps)))], react.createElement("div", {
        className: "item__country",
    }, ...children)), (props_3 = [new HTMLAttr(65, "item__message"), new HTMLAttr(115, 500), new DOMAttr(9, (e_1) => {
        messageState[1](Browser_Types_Event__Event_get_Value(e_1));
    }), new HTMLAttr(161, messageState[0]), new HTMLAttr(128, "Skriv ett meddelande här...")], react.createElement("textarea", keyValueList(props_3, 1))), wrappedButton(new ButtonKind(0), (inputRecord_1 = ButtonProps_get_getDefault(), new ButtonProps("Spara", inputRecord_1.Content, (_arg_4) => {
        let dto;
        startImmediate((dto = (new CountryMessage(selectedCountryState[0], messageState[0])), singleton.Delay(() => {
            saveStatusState[1](new SaveStatus_1(1));
            return singleton.Bind(props.SaveFn(dto, props.IsNew), (_arg_1) => {
                const result = _arg_1;
                return singleton.Combine((result.tag === 1) ? ((saveStatusState[1](new SaveStatus_1(3, result.fields[0])), singleton.Zero())) : ((saveStatusState[1](new SaveStatus_1(2)), singleton.Zero())), singleton.Delay(() => {
                    let a;
                    startImmediate((a = delayAsync(2000, () => {
                        saveStatusState[1](new SaveStatus_1(0));
                    }), singleton.Delay(() => singleton.Bind(a, () => singleton.Return(props.LoadSiteWideMessages())))));
                    return singleton.Return();
                }));
            });
        })));
    }, inputRecord_1.Disabled, "site-wide-message-save-btn", saveStatusState[0], inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon)))];
    return react.createElement("div", {
        className: "country-messages__item",
    }, ...children_4);
}, void 0, uncurry(2, void 0), void 0, "renderCountryMessage", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Admin\\SiteWideMessage.fs", 105);

export class SiteWideMessageProps extends Record {
    constructor(LoadSiteWideMessages, SaveSiteWideMessage) {
        super();
        this.LoadSiteWideMessages = LoadSiteWideMessages;
        this.SaveSiteWideMessage = SaveSiteWideMessage;
    }
}

export function SiteWideMessageProps$reflection() {
    return record_type("Admin.SiteWideMessage.SiteWideMessageProps", [], SiteWideMessageProps, () => [["LoadSiteWideMessages", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(CountryMessage$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(CountryMessage$reflection())]], [["ErrorValue", string_type]]])]))], ["SaveSiteWideMessage", lambda_type(CountryMessage$reflection(), lambda_type(bool_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])])))]]);
}

const renderEditSiteWideMessages = FunctionComponent_Of_Z5A158BBF((props) => {
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const countriesLoadState = useSelector((state_1) => state_1.Model.Countries);
    const siteWideMessagesState = react.useState(new LoadState$2(0));
    const loadSiteWideMessages = () => singleton.Delay(() => {
        siteWideMessagesState[1](new LoadState$2(1));
        return singleton.Bind(props.LoadSiteWideMessages(), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0]));
            siteWideMessagesState[1](arg);
            return singleton.Return();
        });
    });
    react.useEffect(() => {
        startImmediate(loadSiteWideMessages());
        switch (countriesLoadState.tag) {
            case 0:
            case 3: {
                reduxDispatch(loadCountriesThunk());
                break;
            }
            default: {
            }
        }
    }, []);
    const matchValue = LoadState_zip(siteWideMessagesState[0], countriesLoadState);
    switch (matchValue.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue.fields[0].split(""));
        }
        case 2: {
            const countrySelectOptions = cons(["", "Välj land"], map((c) => [c.Code.ThreeLetter, c.DisplayName], matchValue.fields[0][1]));
            let createNewCountryMessageHtml;
            const children_2 = [react.createElement("h4", {}, "Skapa nytt"), renderCountryMessage({
                Countries: countrySelectOptions,
                CountryMessage: new CountryMessage("", void 0),
                IsNew: true,
                LoadSiteWideMessages: () => {
                    startImmediate(loadSiteWideMessages());
                },
                SaveFn: Api_saveSiteWideMessage,
            })];
            createNewCountryMessageHtml = react.createElement("div", {}, ...children_2);
            const existingAndNewMessagesHtml = append(map((countryMessage) => renderCountryMessage({
                Countries: countrySelectOptions,
                CountryMessage: countryMessage,
                IsNew: false,
                LoadSiteWideMessages: () => {
                    startImmediate(loadSiteWideMessages());
                },
                SaveFn: Api_saveSiteWideMessage,
            }), matchValue.fields[0][0]), singleton_1(createNewCountryMessageHtml));
            return react.createElement("div", {
                className: "country-messages",
            }, ...existingAndNewMessagesHtml);
        }
        default: {
            return info(getTranslationFrom(translationsLoadState, "Common.WaitingToLoad").split(""));
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderEditSiteWideMessages", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Admin\\SiteWideMessage.fs", 187);

export const view = (() => {
    let children_4;
    const children_6 = [(children_4 = [react.createElement("h2", {}, "Sitewide Message"), react.createElement("footer", {
        className: "blockquote-footer",
    }, "Meddelanden kan vara cachade i upp till 1 min.")], react.createElement("blockquote", {
        className: "blockquote",
    }, ...children_4)), renderEditSiteWideMessages(new SiteWideMessageProps(Api_loadSiteWideMessages, Api_saveSiteWideMessage))];
    return react.createElement("div", {
        className: "site-wide-message-admin p-2",
    }, ...children_6);
})();

